module.exports = __webpack_public_path__ + "200aa2f0e972340ffb4118cc0a55b9e1.jpg";